/*jshint esnext: true */
/*global jQuery, dis */

/* AKQA Script
 Author's name: Dan Sørensen
 Modified by:
 Client name: Danske Regioner
 Date of creation: 19.3.2021
 */


(function ($, dis) {
	"use strict";


	dis.OkportalSearch = function (objectConfiguration) {
		dis.BaseModule.call(this);

		var defaults = {},
			configuration = $.extend(defaults, objectConfiguration),
			dom = {},
			selfScope = this;


		function init() {
			dom.container = $(configuration.container);

			// Popup message run on all pages
			dom.popupMessages = $(".registration__success-message");
			if (dom.popupMessages.length > 0) {
				dom.popupMessages.each((popupIndex) => {
					const popup = $(dom.popupMessages[popupIndex]);
					if (popup.html() !== null && popup.html() !== "") {
						popup.addClass("-is-visible");
					}
				});
			}

			if (dom.container.length > 0) {

				dom.okportalmain = dom.container.find(".okportal-main");
				dom.searchBtn = dom.container.find(".okportal-searchbar__btn");
				dom.searchForm = $('#okportal-searchbar__form');
				dom.datefield = $(".-datepicker");

				dom.profileLink = $(".okportal__profile-link");
				dom.memberId = dom.profileLink.data("memberid");

				dom.searchField = dom.container.find(".okportal-searchbar__seachfields-field.-searchstring");
				dom.loadmorebtn = dom.container.find(".okportal-search__load-more-btn");
				dom.updateLoadmoreBtn = dom.container.find(".okportal-updates__load-more-btn");
				dom.fieldAreaWrapper = dom.container.find(".okportal-searchbar__seachfields-radio-wrapper");
				dom.fieldDocumenttype = dom.container.find(".okportal-searchbar__seachfields-field-documenttype");

				dom.radioToggles = dom.container.find(".okportal-searchbar__seachfields-radio.-toggle");
				dom.radioColAreas = dom.container.find(".okportal-searchbar__seachfields-field-radio-colareas");
				dom.radioItems = dom.container.find(".checkboxlist input[type=checkbox]");
				dom.btnSubtract = dom.container.find(".okportal-searchbar__seachfields__btn-subtract");
				dom.noSearchResultsMessage = $(".okportal-search__results_no-search-results-message");

				dom.filteredResponse = null;
				dom.documentsAmount = 0;
				dom.amountText = 0;
				dom.amountToLoadAtStart = 10;
				dom.loadAmount = 5;
				dom.lastLoaded = dom.amountToLoadAtStart; //first loaded is same as don.amountToLoad
				dom.selectedDocumentType = "Løn";
				dom.copyUrl = "";
				dom.favData = {};

				if (dom.container.length) {
					// dom.searchField = dom.container.find("form input");
					dom.searchResultsAmount = dom.container.find(".okportal-search__document-amount");
					dom.searchResultsList = dom.container.find(".okportal-search__results-list");

				}

				const params = {
					type: selfScope.getUrlParameter('type'),
					area: selfScope.getUrlParameter('area'),
					terms: selfScope.getUrlParameter('terms'),
					validFrom: selfScope.getUrlParameter('validFrom')
				};

				selfScope.getSearchByLink(params);


				dom.datefield.flatpickr({
					format: "d.m.Y",
					altFormat: "d.m.Y",
					altInput: true,
					allowInput: true,
					"locale": "da"
				});
				// dom.datefield.flatpickr.localize();
				//
				// Flatpickr.localize(German);

				selfScope.allowInputInDateField();

				dom.loadmorebtn.on("click", () => selfScope.loadmore());
				dom.updateLoadmoreBtn.on("click", e => selfScope.updateloadmore(e));
				dom.radioToggles.on("click", e => selfScope.toggleDocumenttypes(e.currentTarget));
				// dom.fieldDocumenttype.on("click", e => selfScope.toggleDocumenttypePicker(e));
				dom.radioItems.on("click", e => selfScope.setDocumenttype(e));

				selfScope.handleEnterInSearchInput();
				dom.searchForm.on("submit", e => selfScope.searchFunc(e));
				dom.btnSubtract.on("click", e => selfScope.resetInputField(e));

			}
		}

		selfScope.decodeUrl = function (value) {
			let result = decodeURI(value);
			result = result.replaceAll('+', ' ');

			return result;
		};

		selfScope.searchFunc = function (e = null) {
			if (e !== null) {
				e.preventDefault()
			}

			const date = $(".-datepicker").val();
			const searchString = $(dom.searchField).val();


			if (dom.selectedDocumentType !== "") {
				const params = {};
				params.area = dom.selectedDocumentType;

				// Set search input
				if (searchString !== "") {
					params.terms = searchString;
				}

				// Set search document type
				if ($(dom.fieldDocumenttype).val() !== "") {
					params.type = $(dom.fieldDocumenttype).data("searchvalue");
				}

				// Set search from valid from date
				if (date !== "") {
					params.validFrom = date;
				}

				const str = jQuery.param(params);

				// Getting Favourites data
				if (dom.memberId !== undefined) {
					selfScope.getFavourites(str);
				} else {
					selfScope.getDocuments(str);
				}

				window.history.pushState('Okportal seach', 'Okportal seach', `${location.origin}${location.pathname}?${str}`);
			}

			if (dom.loadmorebtn.hasClass("hide")) {
				dom.loadmorebtn.removeClass("hide");
			}

		};

		//Search field functions
		selfScope.resetInputField = function (e) {
			e.preventDefault();

			$(e.currentTarget).nextAll("input").val("");
		};
		selfScope.allowInputInDateField = function () {

			dom.datefield.on('blur', function (event) {
				var value = $(event.currentTarget).val();

				var $this = $(event.currentTarget).siblings('.flatpickr-input');
				var instance = $this[0]._flatpickr;
				if (instance && value) {
					// We use current format of the input
					var altFormat = instance.config.altFormat;
					var parsedDate = instance.parseDate(value, altFormat);
					var formattedDate = instance.formatDate(parsedDate, altFormat);

					// Value is valid, set the value to flatpickr instance
					if (value === formattedDate) {
						$(event.currentTarget).removeClass('input-validation-error');
						$this.val(instance.formatDate(parsedDate, altFormat));
						instance.setDate(value, true, altFormat);
					}

						// If the value is different from formatted date then it is invalid value
					// then we will add input-validation-error class and focus back to the input
					else {
						$(event.currentTarget).addClass('input-validation-error').focus();
					}
				}
			});
		}
		selfScope.setDocumenttype = function (e) {
			const currentElement = $(e.currentTarget);
			const parent = currentElement.closest(".checkboxlist");
			const AllCheckboxes = parent.find('input[type=checkbox]').not("#" + currentElement.attr('id'));

			window.setTimeout(() => {

				// Deselect all checkboxes when all is checked
				if (currentElement.data('allselector') === true) {
					if (currentElement.prop("checked") === true) {
						AllCheckboxes.each(function (index, element) {
							$(element).prop("checked", false);
						});
					}
				} else {
					// Deselect the all checkbox when checking other items
					const allCheckbox = parent.find('input[data-allselector="true"]:checked');
					$(allCheckbox).prop("checked", false);
				}


				// Set documenttype value in input field
				let value = "",
					text = "";
				const SelectedCheckboxes = parent.find('input[type=checkbox]:checked');
				SelectedCheckboxes.each(function (index, element) {
					var checkbox = $(element);
					value = value === "" ? value + checkbox.val() : value + "," + checkbox.val();
					text = text === "" ? text + checkbox.next().text() : text + "," + checkbox.next().text();
				});

				dom.fieldDocumenttype.data("searchvalue", value);
				dom.fieldDocumenttype.val(text);
			}, 100);


		};
		selfScope.toggleDocumenttypes = function (activeArea, documentTypes = null) {

			// Remove Current active area
			const wasActiveElement = dom.radioColAreas.find(".-is-active");
			wasActiveElement.removeClass("-is-active");

			// set new current DocumentType for the submit query parameter
			dom.selectedDocumentType = activeArea.dataset.searchname;

			// Get activeArea from document area type picker value 0-1
			dom.activeArea = dom.radioColAreas.children()[activeArea.value];
			// set new active area to active
			$(dom.activeArea).addClass("-is-active");
			$(dom.fieldDocumenttype).addClass("-is-active");


			// if documentType != null we know we came from a url and we should check all which match the type
			if (documentTypes !== null) {
				selfScope.findAndCheckDocumenttypes(documentTypes);
			}

			// Find checked checkboxes in new activated area, if none then check the first checkbox button
			const checkedcheckboxes = $(dom.activeArea).find('.checkboxlist input[type=checkbox]:checked');
			let value = "",
				text = "";

			if (checkedcheckboxes.length > 0) {
				// If there is already a checked RadioBtn then get the value of this to the input field
				checkedcheckboxes.each((index, element) => {
					var checkbox = $(element);
					value = value === "" ? value + checkbox.val() : value + "," + checkbox.val();
					text = text === "" ? text + checkbox.next().text() : text + "," + checkbox.next().text();
				});

			} else {
				// If no area is set in the opened area then set the first item as checked and get the first items value

				// Maybe it shall not check the first item when clicked because type is not mandatory any more.
				// const firstRadioElement = $(dom.activeArea).find('input[type=radio]')[0];
				// $(firstRadioElement).attr('checked', 'checked');
				// value = $(firstRadioElement)[0].value;
			}


			// Setting the input field to the value just found from the cheked radio btn
			dom.fieldDocumenttype.val(text);
			dom.fieldDocumenttype.data("searchvalue", value);
		};
		selfScope.findAndCheckDocumenttypes = function (documentTypes) {
			//When other documentType is selected set ALL checkbox to false.
			const allCheckbox = $(dom.activeArea).find(".checkboxlist input[data-allselector=true]");
			allCheckbox.prop("checked", false);

			if (documentTypes.includes(",")) {
				const documentTypeList = documentTypes.split(",");
				documentTypeList.forEach((documentType) => {
					const checkbox = $(dom.activeArea).find(".checkboxlist input[value=" + documentType + "]");
					if (checkbox !== undefined) {
						checkbox.prop("checked", true);
					}
				});
			} else {
				const checkbox = $(dom.activeArea).find(".checkboxlist input[value=" + documentTypes + "]");
				if (checkbox !== undefined) {
					checkbox.prop("checked", true);
				}
			}
		};
		selfScope.toggleDocumenttypePicker = function (e) {

			$(e.currentTarget).parent().toggleClass("-is-closed");

			$(e.currentTarget).toggleClass("-is-active");

			const colIsActive = $(dom.radioColAreas).find(".-is-active");
			if (colIsActive.length > 0) {
				$(colIsActive).removeClass("-is-active");
				dom.fieldDocumenttype.val("");
			} else {

				dom.radioTogglesChecked = dom.container.find(".okportal-searchbar__seachfields-radio-wrapper input[type=radio]:checked");
				const openValue = $(dom.radioTogglesChecked).val();
				//find checked radiobutton in current selected area type
				const openRadiobuttonlist = $(dom.radioColAreas.children()[openValue]).find(".radiobuttonlist");
				const CurrentCheckedDocumentType = openRadiobuttonlist.find("input[type=radio]:checked");
				if (CurrentCheckedDocumentType !== undefined) {
					dom.fieldDocumenttype.val(CurrentCheckedDocumentType.val());
				}

				openRadiobuttonlist.parent().addClass("-is-active");
			}
		};

		selfScope.loadmore = function () {
			selfScope.appendItems(dom.lastLoaded, dom.loadAmount);

			if (dom.lastLoaded >= dom.filteredResponse.length) {
				dom.loadmorebtn.addClass("hide");
			}
		};
		selfScope.updateloadmore = function (e) {

			var element = $(e.currentTarget);
			const parentContainer = element.closest(".okportal-updates");
			const list = parentContainer.find(".okportal-updates__list");
			list.addClass("-show-all-items");
			element.addClass("hide");
		};

		// Function for fav
		selfScope.getFavourites = function (str, url = "") {

			const urltest = `${location.origin}/umbraco/api/OkPortalFavourites/GetFavourites/?memberId=${dom.memberId}`;
			if (urltest !== "") {
				url = urltest;
			}

			const promise = Promise.resolve($.ajax({
				url: url
			}));

			promise.then(data => {
				dom.favData = data;
				selfScope.getDocuments(str);
			}).catch(error => alert(error));
		};
		selfScope.setFavourite = function (contentId, url = "") {

			const urltest = `${location.origin}/umbraco/api/OkPortalFavourites/AddFavourite/?contentId=${contentId}&memberId=${dom.memberId}`;
			if (urltest !== "") {
				url = urltest;
			}

			return Promise.resolve($.ajax({
				url: url,
				type: "POST",
			}));
		};
		selfScope.removeFavourite = function (rowId, url = "") {

			const urltest = `${location.origin}/umbraco/api/OkPortalFavourites/RemoveFavourite/?id=${rowId}`;
			if (urltest !== "") {
				url = urltest;
			}

			return Promise.resolve($.ajax({
				url: url,
				type: "DELETE",
			}));
		};


		// selfScope.GetDocumentById = function (mediaNodeId) {
		//
		// 	const url = `${location.origin}/GetDocumentById?mediaNodeId=${mediaNodeId}`;
		//
		// 	return Promise.resolve($.ajax({
		// 		url: url,
		// 		type: "GET",
		// 		async: false,
		// 	}));
		// };
		selfScope.getDocuments = function (str) {

			//clear search result
			$(dom.searchResultsList).empty();
			dom.documentsAmount = 0;

			var url = `${location.origin}/umbraco/api/okportalsearch/search?${str}`;

			if (url !== "") {
				dom.container.addClass("-is-loading");
				$.ajax(url, {
					method: "GET",
					cache: false,
					success: function (response) {

						if (response.items.length > 0) {
							dom.okportalmain.removeClass("-no-results-show");
							dom.filteredResponse = selfScope.filterDocumentsInItems(response.items);
							// Put new list of articles in DOM
							selfScope.appendItems(0, dom.amountToLoadAtStart);

							// Scroll to top of list of articles, if it's outside viewport
							if (dom.searchForm.offset().top > document.documentElement.scrollTop) {
								$("html, body").animate({
									scrollTop: dom.searchForm.offset().top
								}, 500);
							}
						} else {
							dom.okportalmain.removeClass("-no-results");
							dom.okportalmain.addClass("-no-results-show");
						}

						dom.container.removeClass("-is-loading");
					}
				});
			}
		};
		selfScope.getCopyUrlFromPath = function (item) {
			const itemPath = item.path.split(',');

			const pathToItem = itemPath.slice(itemPath.length - 3, itemPath.length);
			const ariaId = pathToItem[0];
			const subareaId = pathToItem[1];
			const collectionName = selfScope.getCollectionNameFromSearchRadioTogglesChecked();

			return `${location.origin}/numerisk?collectionName=${collectionName}&areaid=${ariaId}&subareaid=${subareaId}&agreementid=`;
		};
		selfScope.getotherMaterialUrlFromMaterialPath = function (item) {
			const itemPath = item.path.split(',');

			const pathToItem = itemPath.slice(itemPath.length - 3, itemPath.length);
			const ariaId = pathToItem[0];
			const subareaId = pathToItem[1];
			const collectionName = item.collectionName;

			return `${location.origin}/numerisk?collectionName=${collectionName}&areaid=${ariaId}&subareaid=${subareaId}&agreementid=${item.id}`;
		};

		selfScope.filterDocumentsInItems = function (items) {
			const currentDate = new Date();
			let result = [];

			$.each(items, function () {
				const currentDocuments = $(this)[0].documents;
				if (currentDocuments === null)
					return;
				const activeDocuments = currentDocuments.reduce(function (result, item) {
					const itemValidFromDate = new Date(item.validFrom);
					const itemValidToDate = new Date(item.validTo);

					if (selfScope.isValidDate(itemValidFromDate)) {
						//check if item has a valid to date if not it must be a active item, so just check if the current date is after the from date, then we know the to date isn't set yet.
						if (!selfScope.isValidDate(itemValidToDate)) {
							if (currentDate.getTime() > itemValidFromDate.getTime()) {
								result.push(item);
							}
						} else {
							// And if the item has a to date then check if the item is between the two dates.
							if (currentDate.getTime() > itemValidFromDate.getTime() && currentDate.getTime() < itemValidToDate.getTime()) {
								result.push(item);
							}
						}
					}
					return result;
				}, []);

				const futureDocuments = currentDocuments.reduce(function (result, item) {

					const itemValidFromDate = new Date(item.validFrom);

					if (selfScope.isValidDate(itemValidFromDate)) {
						if (currentDate.getTime() < itemValidFromDate.getTime()) {
							result.push(item);
						}
					}
					return result;
				}, []);

				const historyDocuments = currentDocuments.reduce(function (result, item) {

					const itemValidFromDate = new Date(item.validFrom);
					const itemValidToDate = new Date(item.validTo);

					if (selfScope.isValidDate(itemValidFromDate)) {
						if (selfScope.isValidDate(itemValidToDate)) {
							if (currentDate.getTime() > itemValidFromDate.getTime() && currentDate.getTime() > itemValidToDate.getTime()) {
								result.push(item);
							}
						}
					}

					return result;
				}, []);


				result = activeDocuments.concat(futureDocuments).concat(historyDocuments);
				console.log(result)

				// setting the amounts of document found in the search
				dom.documentsAmount = dom.documentsAmount + currentDocuments.length;


				$(this)[0].documents = result;
			});

			return items;
		};
		selfScope.setAmounttext = function () {
			// Put new list of articles in DOM

			dom.amountText = dom.filteredResponse.length + (dom.filteredResponse.length > 1 ? " resultater" : " resultat");
			dom.amountText = dom.amountText + " med " + dom.documentsAmount + (dom.documentsAmount > 1 ? " dokumenter" : " dokument");

			dom.searchResultsAmount.html(dom.amountText);
		};
		selfScope.appendItems = function (skip, take) {

			if (dom.filteredResponse !== null) {
				dom.filteredResponse.slice(skip, skip + take).forEach(function (element) {
					//Add documents to count
					// dom.documentsAmount = dom.documentsAmount + element.documents.length;

					dom.okportalmain.removeClass("-no-results");
					dom.searchResultsList.append(selfScope.documentWrapperItem(element));
				});

				selfScope.setAmounttext();
			}

			//calculate next skip with last load amount.
			// if skip is 0 then we know its the first append of the search, and then lastloaded must not be updated, because its the same as amoutToLoad at first append
			if (skip !== 0) {
				// if all items not shown show load more btn
				dom.lastLoaded = dom.lastLoaded + dom.loadAmount;

			} else {
				// Because dom.lastLoaded will change according to multiple search we have to set this back to dom.amountToLoadAtStart when making a new search.
				dom.lastLoaded = dom.amountToLoadAtStart;
			}

			// If all items is visible hide load more btn
			if (dom.filteredResponse.length - dom.lastLoaded > 0) {
				dom.loadmorebtn.removeClass("hide");
			} else {
				dom.loadmorebtn.addClass("hide");
			}


			selfScope.handleCopyUrl();
			selfScope.handleFav();
			selfScope.handleOtherMaterial();

		};


		selfScope.documentWrapperItem = function (item) {

			let hasItemAsFav = false,
				currentFavItem = null;

			if (!jQuery.isEmptyObject(dom.favData)) {

				// reduce to only item
				currentFavItem = dom.favData.reduce(function (result, reduceItem) {
					if (reduceItem.contentId === item.nodeId) {
						result = reduceItem;
					}
					return result;
				}, {});

				if (!jQuery.isEmptyObject(currentFavItem)) {
					hasItemAsFav = true;
				}
			}

			const copyurl = selfScope.getCopyUrlFromPath(item);

			var documentsHtml = "";
			if (item.documents !== null) {
				item.documents.forEach(function (document) {
					documentsHtml = documentsHtml + selfScope.documentItem(document);
				});
			}

			return selfScope.templating('' +
				'<li>' +
				'<div class="accordion-box__content">' +
				'<div class="accordion-box__content__item">' +
				'<input type="radio" name="accordion-{{id}}" id="{{id}}">' +
				'<label class="accordion-box__content__item__head" for="{{id}}">' +
				'<h2 class="item__heading">{{heading}}</h2>' +
				'<p class="item__placement"><span>Placering i indholdsfortegnelse: </span>{{mainAreaNumber}} - {{mainAreaHeadline}} -> {{areaNumber}} - {{areaHeadline}}</p>' +
				'<span class="icon"><svg role="img" aria-label="Op ned pil"><use xlink:href="/static/dist/icons.svg#arrow-down"></use></svg></span>' +
				'<label><input type="radio" name="accordion-{{id}}"></label>' +
				'</label>' +
				'<div class="accordion-box__content__item__body">' +
				'<div class="accordion-box__content__item__body__inside document__wrapper">' +
				'<div class="document">' +
				'<div class="document__actions">' +
				'<div class="document__actions-col1">' +
				(item.otherMaterial !== null ? '<button class="document__actions-showOtherMaterial" data-agreementid="{{id}}"><span class="text">Vis andet relevant materiale</span><span class="icon"><svg role="img" aria-label="Op ned pil"><use xlink:href="/static/dist/icons.svg#arrow-down"></use></svg></span></button>' : '') +
				'<div class="materials-container"></div></div>' +
				'<div class="document__actions-col2">' +
				'<button class="document__actions-copyLink" data-copyUrl="{{copyurl}}">Kopier link<svg role="img" aria-label="Kopier link ikon"><use xlink:href="/static/dist/icons.svg#link"></use></svg>' +
				'<span class="document__actions-copyLink-checkmark"><svg role="img" aria-label="Kopier link ikon checkmark"><use xlink:href="/static/dist/icons.svg#checkmark"></use></svg></span>' +
				'</button>' +
				(dom.memberId !== undefined ? '' +
					'<button data-contentid="{{id}}" data-rowid="{{rowId}}" class="document__actions-addFavorites ' + (hasItemAsFav ? "-is-faved" : "") + '" >' +
					'<span class="add-text">Tilføj favoritter</span><span class="remove-text">Fjern favoritter</span><svg role="img" aria-label="Tilføj til favoritter ikon"><use xlink:href="/static/dist/icons.svg#heart-like"></use></svg><svg role="img" aria-label="Document er tilføjet favoritter ikon"><use xlink:href="/static/dist/icons.svg#heart-like-fill"></use></svg>' +
					'</button>' : '' +
					'<a class="document__actions-addFavorites login-button-modal open-modal" href="#login-form" >' +
					'Tilføj favoritter<svg role="img" aria-label="Tilføj til favoritter ikon"><use xlink:href="/static/dist/icons.svg#heart-like"></use></svg><svg role="img" aria-label="Document er tilføjet favoritter ikon"><use xlink:href="/static/dist/icons.svg#heart-like-fill"></use></svg>' +
					'</a>') +
				'</div>' +
				'</div>' +
				documentsHtml +
				'</div>' +
				'</div>' +
				'</div>' +
				'</div>' +
				'</div>' +
				'</li>'.toString(), {
				id: item.nodeId,
				rowId: (currentFavItem !== null ? currentFavItem.id : ""),
				heading: item.type + " : " + (item.agreementNumber !== null ? item.agreementNumber : item.areaNumber) + " - " + item.heading,
				mainAreaNumber: item.mainAreaNumber,
				mainAreaHeadline: item.mainAreaHeadline,
				areaNumber: item.areaNumber,
				areaHeadline: item.areaHeadline,
				copyurl: copyurl + item.nodeId,
			});
		};
		selfScope.documentItem = function (item) {
			//format dates
			var validFromDate = new Date("0001-01-01T00:00:00");

			if (item.validFrom !== null) {
				validFromDate = new Date(item.validFrom);
			}

			// getMonth counting from 0 so we have to add 1 to getMonth
			var validFromDateMonth = validFromDate.getMonth() + 1;
			var validFromDateFormated = (validFromDate.getDate() > 9 ? validFromDate.getDate() : '0' + validFromDate.getDate()) + "." + (validFromDateMonth > 9 ? validFromDateMonth : '0' + validFromDateMonth) + "." + validFromDate.getFullYear();


			var validToDate;
			if (item.validTo !== null) {
				validToDate = new Date(item.validTo);
			} else {
				validToDate = new Date("0001-01-01T00:00:00");
			}

			var validToDateMonth = validToDate.getMonth() + 1;
			var validToDateFormated = (validToDate.getDate() > 9 ? validToDate.getDate() : '0' + validToDate.getDate()) + "." + (validToDateMonth > 9 ? validToDateMonth : '0' + validToDateMonth) + "." + validToDate.getFullYear();


			//active future or history
			var dateActivationTag = selfScope.getDateActivationText(validFromDate, validToDate);
			var activationTagText = (dateActivationTag === "--active" ? "Aktiv" : (dateActivationTag === "--history" ? "Historisk" : "Fremtidig"));


			//Get Media Url
			let mediaUrl = null;
			if (item.mediaNodeId !== null && item.mediaNodeId !== "") {
				// const promise = selfScope.GetDocumentById(item.mediaNodeId);
				// promise.then(data => mediaUrl = data);

				mediaUrl = `${location.origin}${item.mediaUrl}`;
			}


			return selfScope.templating('' +
				'<div class="document__inner ' + dateActivationTag + '">' +
				'<div class="document__title"><h3>{{description}}</h3></div>' +
				'<div class="document__description">{{description}}</div>' +
				'<div class="document__type">' +
				'<button class="document__type-btn btn -primary">{{type}}</button>' +
				'</div>' +
				'<div class="document__dates-wrapper">' +
				'<label class="document__dates-tag ' + dateActivationTag + '">' + activationTagText + '</label>' +
				'<div class="document__dates">' +
				'<div class="document__dates-validFrom">' +
				'<p class="document__dates-validFrom-labels">Gyldig fra :&nbsp;</p><p class="document__dates-validFrom-date">{{validFrom}}</p>' +
				'</div>' +
				(selfScope.isValidDate(validToDate) ? '' +
					'<div class="document__dates-validTo">' +
					'<p class="document__dates-validTo-labels">Gyldig til :&nbsp;</p><p class="document__dates-validTo-date">{{validTo}}</p>' +
					'</div>' : '') +
				'</div>' +
				'</div>' +
				'<div class="document__download">' +
				(mediaUrl === null ? '' : '' +
					'<a href="{{mediaUrl}}" target="_blank" class="document__download-link ' + dateActivationTag + '"><span class="document__download-text">Hent dokument</span><svg role="img" aria-label="Download pil"><use xlink:href="/static/dist/icons.svg#download"></use></svg></a>') +
				'</div>' +
				'</div>'.toString(), {
				description: item.description,
				title: item.title,
				type: item.type,
				validFrom: validFromDateFormated,
				validTo: validToDateFormated,
				mediaUrl: mediaUrl
			});
		};

		//Set if document is active
		selfScope.getDateActivationText = function (validFromDate, validToDate) {
			var currentDate = new Date();

			if (selfScope.isValidDate(validFromDate)) {
				if (currentDate.getTime() > validFromDate.getTime()) {
					if (validToDate.getTime() > currentDate.getTime() || !selfScope.isValidDate(validToDate)) {
						return '--active';
					} else {
						return '--history';
					}
				} else {
					return '--future';
				}
			} else if (selfScope.isValidDate(validToDate))//Future
			{
				if (validToDate.getTime() > currentDate.getTime()) {
					return '--active';
				} else {
					return '--history';
				}
			} else {
				return '--future';
			}
		};

		// Check if date is valid
		selfScope.isValidDate = function (d) {

			return d instanceof Date && !isNaN(d) && d.getTime() !== new Date("0001-01-01T00:00:00").getTime();
		};

		selfScope.handleCopyUrl = function () {

			const copyBtns = dom.container.find(".document__actions-copyLink");
			copyBtns.on("click", e => {

				const currentBtn = $(e.currentTarget)[0];

				$(currentBtn).addClass("-is-copied");
				dom.copyUrl = currentBtn.dataset.copyurl;

				// Copy current page href
				var dummyInput = document.createElement('input');

				document.body.appendChild(dummyInput);
				dummyInput.value = dom.copyUrl;
				dummyInput.select();
				document.execCommand('copy');
				document.body.removeChild(dummyInput);

				window.setTimeout(() => {
					$(currentBtn).removeClass("-is-copied");
				}, 2000);

			});
		};
		selfScope.handleFav = function () {

			const favedBtns = dom.container.find(".document__actions-addFavorites");

			if (favedBtns.prop("tagName") !== "A") {
				favedBtns.on("click", e => {

					const currentBtn = $(e.currentTarget)[0];
					const contentId = currentBtn.dataset.contentid;
					const rowId = currentBtn.dataset.rowid;
					$(currentBtn).addClass("-is-loading");

					// If element is already in fav list
					if (!$(currentBtn).hasClass("-is-faved")) {
						// Setting favourite data
						const promise = selfScope.setFavourite(contentId);
						promise.then(data => {
							currentBtn.dataset.rowid = data;
							$(currentBtn).removeClass("-is-loading");
							$(currentBtn).addClass("-is-faved");
						}).catch(error => window.console.log(error));
					} else {
						// Removeing favourite data
						const promise = selfScope.removeFavourite(rowId);
						promise.then(() => {
							currentBtn.dataset.rowid = "";
							$(currentBtn).removeClass("-is-loading");
							$(currentBtn).removeClass("-is-faved");
						}).catch(error => window.console.log(error));
					}

				});
			} else {
				const loginModal = new dis.JqueryModal();
			}

		};
		selfScope.handleOtherMaterial = function () {

			const materialBtns = dom.container.find(".document__actions-showOtherMaterial");

			materialBtns.on("click", e => {
				const materialBtn = $(e.currentTarget),
					btnContainer = materialBtn.parent(),
					materialsContainer = materialBtn.next(),
					agreementid = materialBtn.data("agreementid");

				if (materialBtn.hasClass("-is-active")) {
					materialsContainer.html("");
					materialBtn.removeClass("-is-active");
					materialBtn.find(".text").html("Vis andet relevant materiale");
				} else {
					btnContainer.addClass("-is-loading");
					const promise = selfScope.getOtherMaterial(agreementid);
					promise.then(data => {
						btnContainer.removeClass("-is-loading");

						if (data.length > 0) {
							materialBtn.find(".text").html("Skjul andet relevant materiale");
						}

						materialBtn.addClass("-is-active");

						data.forEach(function (element) {

							const elementUrl = selfScope.getotherMaterialUrlFromMaterialPath(element);

							materialsContainer.append("<a class='materiallinks' target='_blank' href='" + elementUrl + "'>" + element.headline + "</a>");
						});

					}).catch(error => window.console.log(error));
				}
			});

		};
		selfScope.handleEnterInSearchInput = function () {
			dom.searchField.on('keypress', function (event) {
				if (event.keyCode === 13) {
					event.preventDefault();
					selfScope.searchFunc();
				}
			});
		}
		selfScope.getOtherMaterial = function (agreementId) {

			const url = `${location.origin}/umbraco/api/okportalcontent/getothermaterialbyagreementid?agreementId=${agreementId}`;

			return Promise.resolve($.ajax({
				url: url,
				type: "GET",
			}));
		};
		selfScope.getCollectionNameFromSearchRadioTogglesChecked = function () {
			dom.radioTogglesChecked = dom.container.find(".okportal-searchbar__seachfields-radio-wrapper input[type=radio]:checked")[0];
			return dom.radioTogglesChecked.dataset.searchname;
		};

		selfScope.getSearchByLink = function (params) {

			if (params.area !== false) {
				//area
				// set area radio, this must be set first in the process else the active radiocolarea could be the wrong area.
				const area = dom.fieldAreaWrapper.find(`[data-searchname=${params.area}]`);
				area.attr('checked', 'checked');

				//type
				if (params.type !== false) {
					window.setTimeout(() => {
						selfScope.toggleDocumenttypes(area[0], params.type);
					}, 100);
				} else {
					// If the type is empty just delete it
					delete params.type;
				}

				//date
				if (params.validFrom !== false) {
					dom.datefield.val(params.validFrom);
				} else {
					// If the date is empty just delete it
					delete params.validFrom;
				}

				// terms
				// Set search field after decoding the url
				if (params.terms !== false) {
					dom.searchField.val(selfScope.decodeUrl(params.terms));
				} else {
					// If the terms is empty just delete it
					delete params.terms;
				}

				const str = jQuery.param(params);

				// When all search field has been set get documents
				// Getting Favourites data
				// Getting Favourites data
				if (dom.memberId !== undefined) {
					selfScope.getFavourites(str);
				} else {
					selfScope.getDocuments(str);
				}
			}
		};


		selfScope.onReady(init);
	};

	dis.OkportalSearch.prototype = new dis.BaseModule();
	dis.OkportalSearch.constructor = dis.OkportalSearch;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.
}(jQuery, dis));





